export default function usePageRouteQuery() {
	const pageQuery = useMonadicRouteQuery('page');

	return computed({
		get(): number {
			return parseInt(pageQuery.value ?? '1') || 1;
		},
		set(value: number) {
			pageQuery.value = value === 1
				? null
				: value.toString();
		},
	});
}
